import {
  OPT_TASKS_LIST_TYPE_EMAIL_ID,
  OPT_TASKS_LIST_TYPE_SMS_ID,
  STORE_KEY_ID_LIST
} from 'Constants/'
import { storeGet } from 'Helpers/localStorage'
import { notifyParent } from 'Helpers/notifyParent'
import { Actions } from 'mailup-web-components'
import {
  modalCopy,
  modalDelete,
  modalSimulate,
  modalStatistics
} from 'Pages/TasksList/recoil/state/modals'
import { pageState } from 'Pages/TasksList/recoil/state/page'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilValue, useSetRecoilState } from 'recoil'

const ActionsMenu = ({ item, moreCountMessage }) => {
  const intl = useIntl()
  const idList = storeGet(STORE_KEY_ID_LIST)
  const history = useHistory()
  const setModalCopyState = useSetRecoilState(modalCopy)
  const setModalSimulate = useSetRecoilState(modalSimulate)
  const setModalStatistics = useSetRecoilState(modalStatistics)
  const setModalDelete = useSetRecoilState(modalDelete)
  const { canCreateTrigger } = useRecoilValue(pageState)

  const handleEdit = () => {
    history.push(`/automation/task/${item.Id}`)
  }

  const handleCopy = () => {
    setModalCopyState((prev) => ({
      ...prev,
      show: true,
      idTask: item.Id
    }))
  }

  const handleSimulate = () => {
    setModalSimulate((prev) => ({
      ...prev,
      show: true,
      idTask: item.Id,
      idSimulate: undefined,
      fetchData: false,
      currentIteration: 0,
      interval: 250,
      simulateStatus: undefined,
      simulateProcessed: undefined,
      simulateDiscarded: undefined
    }))
  }

  const handleStats = () => {
    if (item.Detail.Action === OPT_TASKS_LIST_TYPE_EMAIL_ID) {
      moreCountMessage === 0 &&
        setModalStatistics((prev) => ({
          ...prev,
          show: true
        }))

      moreCountMessage > 0 &&
        notifyParent('redirectMainFrame', [
          `/console/statistics_app_redirector.aspx?r=/stats/sendouts/sending/mode/messages/0/${item.Detail.IdMessage}`
        ])
    }

    if (item.Detail.Action === OPT_TASKS_LIST_TYPE_SMS_ID) {
      moreCountMessage === 0 &&
        setModalStatistics((prev) => ({
          ...prev,
          show: true
        }))

      moreCountMessage > 0 &&
        notifyParent('redirectMainFrame', [
          `/console/logInvii_SMS2.aspx?source=triggeredlist&list=${idList}&newsletter=${item.Detail.IdMessage}`
        ])
    }
  }

  const handleDelete = (value) => {
    setModalDelete((prev) => ({
      ...prev,
      show: true,
      idTask: item.Id,
      name: item.Name
    }))
  }

  const menuActions = []

  menuActions.push({
    label: intl.formatMessage({ id: 'Load.TriggersList.Edit' }),
    'data-mu-test': 'triggers-list-edit',
    separator: false,
    onClick: handleEdit
  })

  canCreateTrigger &&
    menuActions.push({
      label: intl.formatMessage({ id: 'Load.TriggersList.Copy' }),
      'data-mu-test': 'triggers-list-copy',
      separator: false,
      onClick: handleCopy
    })

  menuActions.push({
    label: intl.formatMessage({ id: 'Load.TriggersList.Simulate' }),
    'data-mu-test': 'triggers-list-simulate',
    separator: false,
    onClick: handleSimulate
  })

  item.Detail.Action !== -1 &&
    menuActions.push({
      label: intl.formatMessage({ id: 'Load.TriggersList.Statistic' }),
      'data-mu-test': 'triggers-list-statistic',
      separator: false,
      onClick: handleStats
    })

  menuActions.push({
    label: intl.formatMessage({ id: 'Load.TriggersList.Delete' }),
    'data-mu-test': 'triggers-list-delete',
    separator: true,
    onClick: () => {
      handleDelete()
    }
  })

  return <Actions items={menuActions} />
}

ActionsMenu.propTypes = {
  item: PropTypes.object,
  moreCountMessage: PropTypes.number
}

export default ActionsMenu
